import { render, staticRenderFns } from "./Kn.vue?vue&type=template&id=039b116a&"
import script from "./Kn.vue?vue&type=script&lang=js&"
export * from "./Kn.vue?vue&type=script&lang=js&"
import style0 from "./Kn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports